import React, { useState, useEffect } from 'react';
import { Chip, Fade, Box } from '@mui/material';
import { WifiOffIcon } from "../../icons";
export const OfflineIndicator: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Fade in={!isOnline}>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1300,
        }}
      >
        <Chip
          icon={<WifiOffIcon />}
          label="Sin internet"
          color="error"
          size="small"
          sx={{
            fontWeight: 'bold',
            boxShadow: 3,
          }}
        />
      </Box>
    </Fade>
  );
};
